import axios from 'axios';

import { handleError } from '@/shared/services/api';

export default {
  baseUrl() {
    return `${window.api_url}/organization/attachments`;
  },

  create(attachment) {
    return axios.post(this.baseUrl(), { attachment }).catch(handleError);
  },

  destroy(id) {
    return axios.delete(`${this.baseUrl()}/${id}`).catch(handleError);
  },

  index(params) {
    return axios.get(this.baseUrl(), { params }).catch(handleError);
  },

  get(id) {
    return axios.get(`${this.baseUrl()}/${id}`).catch(handleError);
  },

  update(id, attachment) {
    return axios.patch(`${this.baseUrl()}/${id}`, { attachment }).catch(handleError);
  },
};
